import { css } from '@emotion/core';
import { tokens, applyFont, buttonNormalize } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var defaultHoverBackground = colors.neutral.subdued.default;
var _ref = {
  name: "1xb8cnv",
  styles: "padding-left:15px;padding-right:15px;"
};
var _ref2 = {
  name: "qbubgm",
  styles: "margin-left:0;"
};
var _ref3 = {
  name: "540lu8",
  styles: "width:14px;height:14px;"
};
var _ref4 = {
  name: "9uy14h",
  styles: "width:24px;height:24px;"
};
var _ref5 = {
  name: "1y6ic72",
  styles: "margin-left:10px;"
};
var _ref6 = {
  name: "f38rbf",
  styles: "margin-left:32px;"
};
export default (_ref7 => {
  var _ref7$hoverBackground = _ref7.hoverBackground,
    hoverBackground = _ref7$hoverBackground === void 0 ? defaultHoverBackground : _ref7$hoverBackground,
    hoverText = _ref7.hoverText,
    passive = _ref7.passive,
    selected = _ref7.selected,
    rightIconSize = _ref7.rightIconSize,
    hasPadding = _ref7.hasPadding,
    hasLeftIcon = _ref7.hasLeftIcon;
  var highlight = /*#__PURE__*/css("background-color:", hoverBackground, ";*{color:", hoverText, " !important;}");
  var container = /*#__PURE__*/css(buttonNormalize, " display:flex;flex-direction:column;align-items:stretch;width:100%;background-color:", colors.neutral.surface.default, ";padding:6px 0;", hasPadding && _ref, " ", !passive && /*#__PURE__*/css("cursor:pointer;&:hover{", highlight, "}"), " ", selected && !passive && highlight);
  var infoContainer = /*#__PURE__*/css("display:flex;flex-direction:row;margin:2px;", !hasLeftIcon && _ref2, " align-items:center;");
  var leftIcon = /*#__PURE__*/css("display:flex;width:20px;height:20px;color:", colors.neutral.heavy.default, ";");
  var rightIcon = /*#__PURE__*/css("display:block;color:", colors.neutral.heavy.default, ";", rightIconSize === 'small' && _ref3, " ", rightIconSize === 'medium' && _ref4);
  var title = /*#__PURE__*/css("flex:auto;", hasLeftIcon && _ref5, " color:", colors.neutral.heavy.default, ";", applyFont(typography.body), " line-height:20px;& strong{", applyFont(typography.bodyBold), ";line-height:20px;}");
  var label = /*#__PURE__*/css(hasLeftIcon && _ref6, " margin-right:28px;height:20px;color:", colors.neutral.base.default, ";", applyFont(typography.mini));
  return {
    container,
    infoContainer,
    leftIcon,
    rightIcon,
    title,
    label
  };
});